import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=573cf3ae&"
import script from "./companies.ts?vue&type=script&lang=ts&"
export * from "./companies.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports